import React, { useEffect } from "react";
import Button from "../../Elements/Button/Button.js";
import config from "config";
import Image from "components/Elements/Image/Image.tsx";
import SendMailToVerify from "./SendMailToVerify.js";
import EditMailRegistration from "./EditMailRegistration.js";
import Cookies from "universal-cookie";
import checkCurrDomainIsOrgDomain from "helpers/checkCurrDomainIsOrgDomain.ts";
import Authentication from "components/Reusable/Authentication/index.tsx";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useUser } from "../../../contexts/userContext/userContext.js";
import { useModal } from "../../../contexts/modalContext/modalContext.js";

import "./RegistrationComplete.scss";

const isCustomDomain = checkCurrDomainIsOrgDomain();
const JUMBOMAIL_TEXT = " JUMBOmail";

const RegistrationComplete = () => {
  const { getUserData } = useUser();
  const userData = getUserData();
  const { setModal } = useModal();
  const { getTextByKey, getPath } = useContent();
  const cookies = new Cookies();
  const isTokenExist = cookies.get(config.api.jumbomailApiAuthCookie);
  //if user not loggin - open login modal and if login - return back the page if not - go to home page

  useEffect(() => {
    if (!isTokenExist) {
      setModal({
        modal: Authentication,
        modalSize: "full-modal",
        props: {
          type: "sign-in",
          onSubmitSuccess: () => {
            const cookies = new Cookies();
            const isTokenExist = cookies.get(config.api.jumbomailApiAuthCookie);
            if (!isTokenExist)
              window.location.href = config.baseurl + getPath();
          },
        },
      });
    }
  }, [isTokenExist]);

  const convertInstructionsConst = (str) => {
    let resendStr = "";
    let editStr = "";
    let newStr = str.split("<br>");
    if (newStr) {
      if (newStr[1].includes("#resend#")) {
        resendStr = newStr[1].split("#resend#");
      }
      if (newStr[2].includes("#edit#")) {
        editStr = newStr[2].split("#edit#");
      }
    }

    return newStr ? (
      <div>
        <p>{newStr[0]}</p>
        <p>
          {resendStr[0]}{" "}
          <span
            className="link"
            onClick={() =>
              setModal(() => <SendMailToVerify userData={userData} />)
            }
          >
            {getTextByKey("resend-email-button")}
          </span>
        </p>
        <p>
          {editStr[0]}{" "}
          <span
            className="link"
            onClick={() =>
              setModal(() => <EditMailRegistration userData={userData} />)
            }
          >
            {getTextByKey("click-here")}
          </span>
          {editStr[1]}
        </p>
      </div>
    ) : (
      newStr
    );
  };
  return (
    <div className="incomplete-page complete">
      <div className="section1">
        <div className="header">
          <Image
            name="incomplete/registration-complete-header-decoration"
            ext="png"
            title=""
            alt=""
            className="header-decoration"
          />
          <div className="header-title">
            <h1>
              {getTextByKey("registration-complete-title").replace(
                isCustomDomain ? JUMBOMAIL_TEXT : "",
                ""
              )}
            </h1>
            <div className="title-divider"></div>
            <div className="header-text">
              <div className="inviter-note"></div>
              {getTextByKey("registration-complete-title-description")}
              <br></br>
              {userData.UserName}
            </div>
          </div>
        </div>
        <div className="bottom-decorations">
          <div className="left-decoration">
            <Image
              className="show-on-desktop"
              name="incomplete/clouds-decoration-left"
              ext="png"
              alt=""
              title=""
            />
            <Image
              className="show-on-mobile"
              name="incomplete/clouds-decoration-mobile-left"
              ext="png"
              alt=""
              title=""
            />
          </div>
          <div className="right-decoration">
            {" "}
            <Image
              className="show-on-desktop"
              name="incomplete/clouds-decoration-right"
              ext="png"
              alt=""
              title=""
            />
            <Image
              className="show-on-mobile"
              name="incomplete/clouds-decoration-mobile-right"
              ext="png"
              alt=""
              title=""
            />
          </div>
        </div>
      </div>
      <div className="section2">
        <div className="instructions-text">
          <div className="top">
            {convertInstructionsConst(
              getTextByKey("registration-complete-instructions-text")
            )}
          </div>
          <div className="bottom">
            {getTextByKey("registration-complete-send-mail-text")}
            <a href="/">
              <Button>
                {getTextByKey("send-jumbomail").replace(
                  isCustomDomain ? JUMBOMAIL_TEXT : "",
                  ""
                )}
              </Button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationComplete;
